import React from 'react';

import type { SequenceData } from '../../types';
import { highlightText } from '../../utilities/highlightText';
import { getLiabilityBadge } from '../../utilities/liabilityBadge';

const s = {
  badge: 'text-[11px] font-medium px-1.5 py-0.5 rounded-sm whitespace-nowrap ring-1',
} as const;

interface LiabilityBadgeCellProps {
  sequenceData: SequenceData;
  searchQuery: string;
}

/**
 * Renders a coloured severity badge (Critical / Strong / Mild / None/Weak)
 * with search-term highlighting on the label text.
 */
export function LiabilityBadgeCell({ sequenceData, searchQuery }: LiabilityBadgeCellProps) {
  const badge = getLiabilityBadge(sequenceData);
  return <span className={`${s.badge} ${badge.cls}`}>{highlightText(badge.label, searchQuery)}</span>;
}
